// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.Speeches_yearBrowserContainer__j2-OD {
  display: flex;
  width: 80%;
  margin: 0 auto;
  padding: 20px;
  direction: rtl;
  background: #f8f9fa;
  min-height: 100vh;
  position: relative;
  flex-direction: column;
  align-items: center;
}

.Speeches_pageTitle__TAjyd {
  text-align: center;
  margin-bottom: 40px;
  font-size: 28px;
  color: #1a202c;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.Speeches_yearNavigation__KqMYx {
  /* position: absolute; */
  display: flex;
  bottom: 0;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 40px;
  padding: 15px;
  margin-top: 50px;
  width: 80%;
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.3);
}

.Speeches_navBtn__ygXAD {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  transition: all 0.3s ease;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 75px;
  backdrop-filter: blur(10px);
}

.Speeches_navBtn__ygXAD .Speeches_arrow__l67sp {
  font-size: 20px;
  font-weight: bold;
}

.Speeches_navBtn__ygXAD:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.2);
}

.Speeches_navBtn__ygXAD:disabled {
  background: rgba(255, 255, 255, 0.1);
  cursor: not-allowed;
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.2);
  transform: none;
  box-shadow: none;
}

.Speeches_yearSelector__OTn1i {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.15);
  padding: 6px;
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.Speeches_yearBtn__5uOxZ {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 8px 14px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  width: 55px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(5px);
}

.Speeches_yearBtn__5uOxZ:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
  transform: translateY(-1px);
}

.Speeches_yearBtn__5uOxZ.Speeches_active__G11-v {
  background: rgba(255, 255, 255, 0.9);
  color: #1a5f3f;
  border-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3);
  font-weight: 700;
}

.Speeches_dots__r7Ls5 {
  color: rgba(255, 255, 255, 0.7);
  font-size: 18px;
  font-weight: bold;
  padding: 0 10px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ===== LOADING & ERROR STATES ===== */
.Speeches_loading__XzGte {
  text-align: center;
  width: 80%;
  padding: 60px;
  color: #1a5f3f;
  font-size: 18px;
  font-weight: 600;
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
  border-radius: 16px;
  margin: 20px 0;
  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.1);
}

.Speeches_noArticles__Xqd4D {
  text-align: center;
  padding: 60px;
  color: #64748b;
  font-size: 16px;
  background: linear-gradient(135deg, #f1f5f9 0%, #f8fafc 100%);
  border-radius: 16px;
  margin: 20px 0;
  border: 2px dashed #cbd5e1;
}

/* ===== ARTICLES LIST STYLES (EXACTLY LIKE AUDIO ITEMS) ===== */
.Speeches_articlesList__N8OSE {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 30px;
  width: 100%;
}

.Speeches_articleItem__JtkA0 {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 16px;
  padding: 20px;
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
  width: 100%;
  min-height: 80px;
  box-sizing: border-box;
  cursor: pointer;
}

/* EXACT SAME TOP BORDER ANIMATION AS AUDIO */
.Speeches_articleItem__JtkA0::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #1a5f3f 0%, #22543d 100%);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

/* EXACT SAME HOVER EFFECTS AS AUDIO */
.Speeches_articleItem__JtkA0:hover {
  box-shadow: 0 12px 28px rgba(26, 95, 63, 0.15);
  transform: translateY(-4px);
  border-color: #1a5f3f;
}

.Speeches_articleItem__JtkA0:hover::before {
  transform: scaleX(1);
}

/* ===== ARTICLE CONTENT STYLES ===== */
.Speeches_articleIconContainer__i7yEi {
  margin-left: 16px;
  flex-shrink: 0;
  width: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Speeches_profileImage__GzG3U {
  width: 80px;
  height: 70px;
  border-radius: 12px;
  object-fit: cover;
  transition: all 0.3s ease;
}

.Speeches_profileImage__GzG3U:hover {
  border-color: #1a5f3f;
  transform: scale(1.05);
  box-shadow: 0 8px 16px rgba(26, 95, 63, 0.2);
}

.Speeches_articleContent__FRqH4 {
  flex: 1 1;
  min-width: 0;
  padding: 0 16px;
}

.Speeches_articleTitle__yUU7\\+ {
  font-size: 16px;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 8px 0;
  line-height: 1.4;
  word-wrap: break-word;
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.Speeches_articleMeta__3IQ9z {
  font-size: 12px;
  color: #64748b;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

.Speeches_articleDate__jlQMY {
  color: #1a5f3f;
  font-weight: 600;
  background: rgba(26, 95, 63, 0.1);
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
}

.Speeches_articleSeparator__pYP7Y {
  margin: 0 4px;
  color: #cbd5e1;
}

.Speeches_articleAuthor__bAAah {
  color: #475569;
  font-weight: 600;
  font-size: 11px;
}

.Speeches_articleProfileContainer__W3tet {
  margin-right: 16px;
  flex-shrink: 0;
}

.Speeches_speechIcon__8hhXW {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  object-fit: cover;
  transition: all 0.3s ease;
}

.Speeches_speechIcon__8hhXW:hover {
  border-color: #1a5f3f;
  transform: scale(1.05);
  box-shadow: 0 8px 16px rgba(26, 95, 63, 0.2);
}

/* ===== LOAD MORE SECTION (EXACTLY LIKE AUDIO) ===== */
.Speeches_loadMoreContainer__uYYyW {
  text-align: center;
  margin-top: 40px;
  padding: 30px;
}

.Speeches_loadMoreBtn__o-ztp {
  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);
  color: white;
  border: none;
  border-radius: 14px;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(26, 95, 63, 0.3);
  margin-bottom: 16px;
}

.Speeches_loadMoreBtn__o-ztp:hover {
  background: linear-gradient(135deg, #16543e 0%, #1f4e3a 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.4);
}

.Speeches_showingCount__RirQC {
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  background: rgba(26, 95, 63, 0.1);
  padding: 8px 16px;
  border-radius: 20px;
  display: inline-block;
}

/* ===== RESPONSIVE DESIGN ===== */
@media (max-width: 1024px) {
  .Speeches_articleItem__JtkA0 {
    padding: 16px;
  }

  .Speeches_yearNavigation__KqMYx {
    flex-wrap: wrap;
    gap: 10px;
    position: relative;
  }
}

@media (max-width: 768px) {
  .Speeches_yearBrowserContainer__j2-OD {
    padding: 15px;
    min-height: 400px;
  }

  .Speeches_articleItem__JtkA0 {
    flex-direction: row;
    text-align: right;
    padding: 20px;
  }

  .Speeches_articleIconContainer__i7yEi {
    margin-left: 16px;
  }

  .Speeches_articleContent__FRqH4 {
    padding: 0 16px;
  }

  .Speeches_articleProfileContainer__W3tet {
    margin-right: 16px;
  }

  .Speeches_yearNavigation__KqMYx {
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
    position: relative;
  }

  .Speeches_yearBtn__5uOxZ {
    width: 46px;
  }

  .Speeches_yearSelector__OTn1i {
    order: -1;
    width: 100%;
    justify-content: center;
  }

  .Speeches_articleTitle__yUU7\\+ {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .Speeches_articleItem__JtkA0 {
    padding: 16px;
  }

  .Speeches_profileImage__GzG3U {
    width: 45px;
    height: 45px;
  }

  .Speeches_speechIcon__8hhXW {
    width: 24px;
    height: 24px;
  }

  .Speeches_articleTitle__yUU7\\+ {
    font-size: 14px;
  }

  .Speeches_articleMeta__3IQ9z {
    font-size: 11px;
  }
    .Speeches_yearBtn__5uOxZ {
    width: 35px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Main pages/Speeches.module.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,UAAU;EACV,cAAc;EACd,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,6DAA6D;EAC7D,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,+BAA+B;EAC/B,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;EACtC,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,6DAA6D;EAC7D,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;EAC5D,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA,sCAAsC;AACtC;EACE,8CAA8C;EAC9C,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,uCAAuC;AACvC;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,SAAS;IACT,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;IACT,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;IACE;IACA,WAAW;EACb;AACF","sourcesContent":["\r\n.yearBrowserContainer {\r\n  display: flex;\r\n  width: 80%;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n  direction: rtl;\r\n  background: #f8f9fa;\r\n  min-height: 100vh;\r\n  position: relative;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.pageTitle {\r\n  text-align: center;\r\n  margin-bottom: 40px;\r\n  font-size: 28px;\r\n  color: #1a202c;\r\n  font-weight: 700;\r\n  text-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n}\r\n\r\n.yearNavigation {\r\n  /* position: absolute; */\r\n  display: flex;\r\n  bottom: 0;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  margin-bottom: 40px;\r\n  padding: 15px;\r\n  margin-top: 50px;\r\n  width: 80%;\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\r\n  border-radius: 16px;\r\n  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.3);\r\n}\r\n\r\n.navBtn {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  color: white;\r\n  border: 2px solid rgba(255, 255, 255, 0.3);\r\n  border-radius: 20px;\r\n  padding: 10px 16px;\r\n  cursor: pointer;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  transition: all 0.3s ease;\r\n  height: 44px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  min-width: 75px;\r\n  backdrop-filter: blur(10px);\r\n}\r\n\r\n.navBtn .arrow {\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n}\r\n\r\n.navBtn:hover:not(:disabled) {\r\n  background: rgba(255, 255, 255, 0.3);\r\n  border-color: rgba(255, 255, 255, 0.5);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.navBtn:disabled {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  cursor: not-allowed;\r\n  color: rgba(255, 255, 255, 0.5);\r\n  border-color: rgba(255, 255, 255, 0.2);\r\n  transform: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.yearSelector {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  background: rgba(255, 255, 255, 0.15);\r\n  padding: 6px;\r\n  border-radius: 16px;\r\n  backdrop-filter: blur(10px);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.yearBtn {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  color: white;\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  border-radius: 12px;\r\n  padding: 8px 14px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  transition: all 0.3s ease;\r\n  width: 55px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  backdrop-filter: blur(5px);\r\n}\r\n\r\n.yearBtn:hover {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border-color: rgba(255, 255, 255, 0.4);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.yearBtn.active {\r\n  background: rgba(255, 255, 255, 0.9);\r\n  color: #1a5f3f;\r\n  border-color: rgba(255, 255, 255, 0.9);\r\n  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3);\r\n  font-weight: 700;\r\n}\r\n\r\n.dots {\r\n  color: rgba(255, 255, 255, 0.7);\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  padding: 0 10px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n/* ===== LOADING & ERROR STATES ===== */\r\n.loading {\r\n  text-align: center;\r\n  width: 80%;\r\n  padding: 60px;\r\n  color: #1a5f3f;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);\r\n  border-radius: 16px;\r\n  margin: 20px 0;\r\n  box-shadow: 0 4px 12px rgba(26, 95, 63, 0.1);\r\n}\r\n\r\n.noArticles {\r\n  text-align: center;\r\n  padding: 60px;\r\n  color: #64748b;\r\n  font-size: 16px;\r\n  background: linear-gradient(135deg, #f1f5f9 0%, #f8fafc 100%);\r\n  border-radius: 16px;\r\n  margin: 20px 0;\r\n  border: 2px dashed #cbd5e1;\r\n}\r\n\r\n/* ===== ARTICLES LIST STYLES (EXACTLY LIKE AUDIO ITEMS) ===== */\r\n.articlesList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n  margin-bottom: 30px;\r\n  width: 100%;\r\n}\r\n\r\n.articleItem {\r\n  display: flex;\r\n  align-items: center;\r\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\r\n  border-radius: 16px;\r\n  padding: 20px;\r\n  transition: all 0.3s ease;\r\n  border: 1px solid #e2e8f0;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\r\n  position: relative;\r\n  overflow: hidden;\r\n  width: 100%;\r\n  min-height: 80px;\r\n  box-sizing: border-box;\r\n  cursor: pointer;\r\n}\r\n\r\n/* EXACT SAME TOP BORDER ANIMATION AS AUDIO */\r\n.articleItem::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 3px;\r\n  background: linear-gradient(90deg, #1a5f3f 0%, #22543d 100%);\r\n  transform: scaleX(0);\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n/* EXACT SAME HOVER EFFECTS AS AUDIO */\r\n.articleItem:hover {\r\n  box-shadow: 0 12px 28px rgba(26, 95, 63, 0.15);\r\n  transform: translateY(-4px);\r\n  border-color: #1a5f3f;\r\n}\r\n\r\n.articleItem:hover::before {\r\n  transform: scaleX(1);\r\n}\r\n\r\n/* ===== ARTICLE CONTENT STYLES ===== */\r\n.articleIconContainer {\r\n  margin-left: 16px;\r\n  flex-shrink: 0;\r\n  width: 65px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.profileImage {\r\n  width: 80px;\r\n  height: 70px;\r\n  border-radius: 12px;\r\n  object-fit: cover;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.profileImage:hover {\r\n  border-color: #1a5f3f;\r\n  transform: scale(1.05);\r\n  box-shadow: 0 8px 16px rgba(26, 95, 63, 0.2);\r\n}\r\n\r\n.articleContent {\r\n  flex: 1;\r\n  min-width: 0;\r\n  padding: 0 16px;\r\n}\r\n\r\n.articleTitle {\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  color: #1a202c;\r\n  margin: 0 0 8px 0;\r\n  line-height: 1.4;\r\n  word-wrap: break-word;\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n}\r\n\r\n.articleMeta {\r\n  font-size: 12px;\r\n  color: #64748b;\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 4px;\r\n}\r\n\r\n.articleDate {\r\n  color: #1a5f3f;\r\n  font-weight: 600;\r\n  background: rgba(26, 95, 63, 0.1);\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n  font-size: 11px;\r\n}\r\n\r\n.articleSeparator {\r\n  margin: 0 4px;\r\n  color: #cbd5e1;\r\n}\r\n\r\n.articleAuthor {\r\n  color: #475569;\r\n  font-weight: 600;\r\n  font-size: 11px;\r\n}\r\n\r\n.articleProfileContainer {\r\n  margin-right: 16px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.speechIcon {\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 12px;\r\n  object-fit: cover;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.speechIcon:hover {\r\n  border-color: #1a5f3f;\r\n  transform: scale(1.05);\r\n  box-shadow: 0 8px 16px rgba(26, 95, 63, 0.2);\r\n}\r\n\r\n/* ===== LOAD MORE SECTION (EXACTLY LIKE AUDIO) ===== */\r\n.loadMoreContainer {\r\n  text-align: center;\r\n  margin-top: 40px;\r\n  padding: 30px;\r\n}\r\n\r\n.loadMoreBtn {\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #22543d 100%);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 14px;\r\n  padding: 16px 32px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 6px 20px rgba(26, 95, 63, 0.3);\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.loadMoreBtn:hover {\r\n  background: linear-gradient(135deg, #16543e 0%, #1f4e3a 100%);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 8px 25px rgba(26, 95, 63, 0.4);\r\n}\r\n\r\n.showingCount {\r\n  color: #64748b;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  background: rgba(26, 95, 63, 0.1);\r\n  padding: 8px 16px;\r\n  border-radius: 20px;\r\n  display: inline-block;\r\n}\r\n\r\n/* ===== RESPONSIVE DESIGN ===== */\r\n@media (max-width: 1024px) {\r\n  .articleItem {\r\n    padding: 16px;\r\n  }\r\n\r\n  .yearNavigation {\r\n    flex-wrap: wrap;\r\n    gap: 10px;\r\n    position: relative;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .yearBrowserContainer {\r\n    padding: 15px;\r\n    min-height: 400px;\r\n  }\r\n\r\n  .articleItem {\r\n    flex-direction: row;\r\n    text-align: right;\r\n    padding: 20px;\r\n  }\r\n\r\n  .articleIconContainer {\r\n    margin-left: 16px;\r\n  }\r\n\r\n  .articleContent {\r\n    padding: 0 16px;\r\n  }\r\n\r\n  .articleProfileContainer {\r\n    margin-right: 16px;\r\n  }\r\n\r\n  .yearNavigation {\r\n    flex-wrap: wrap;\r\n    gap: 10px;\r\n    width: 100%;\r\n    position: relative;\r\n  }\r\n\r\n  .yearBtn {\r\n    width: 46px;\r\n  }\r\n\r\n  .yearSelector {\r\n    order: -1;\r\n    width: 100%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .articleTitle {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .articleItem {\r\n    padding: 16px;\r\n  }\r\n\r\n  .profileImage {\r\n    width: 45px;\r\n    height: 45px;\r\n  }\r\n\r\n  .speechIcon {\r\n    width: 24px;\r\n    height: 24px;\r\n  }\r\n\r\n  .articleTitle {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .articleMeta {\r\n    font-size: 11px;\r\n  }\r\n    .yearBtn {\r\n    width: 35px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"yearBrowserContainer": `Speeches_yearBrowserContainer__j2-OD`,
	"pageTitle": `Speeches_pageTitle__TAjyd`,
	"yearNavigation": `Speeches_yearNavigation__KqMYx`,
	"navBtn": `Speeches_navBtn__ygXAD`,
	"arrow": `Speeches_arrow__l67sp`,
	"yearSelector": `Speeches_yearSelector__OTn1i`,
	"yearBtn": `Speeches_yearBtn__5uOxZ`,
	"active": `Speeches_active__G11-v`,
	"dots": `Speeches_dots__r7Ls5`,
	"loading": `Speeches_loading__XzGte`,
	"noArticles": `Speeches_noArticles__Xqd4D`,
	"articlesList": `Speeches_articlesList__N8OSE`,
	"articleItem": `Speeches_articleItem__JtkA0`,
	"articleIconContainer": `Speeches_articleIconContainer__i7yEi`,
	"profileImage": `Speeches_profileImage__GzG3U`,
	"articleContent": `Speeches_articleContent__FRqH4`,
	"articleTitle": `Speeches_articleTitle__yUU7+`,
	"articleMeta": `Speeches_articleMeta__3IQ9z`,
	"articleDate": `Speeches_articleDate__jlQMY`,
	"articleSeparator": `Speeches_articleSeparator__pYP7Y`,
	"articleAuthor": `Speeches_articleAuthor__bAAah`,
	"articleProfileContainer": `Speeches_articleProfileContainer__W3tet`,
	"speechIcon": `Speeches_speechIcon__8hhXW`,
	"loadMoreContainer": `Speeches_loadMoreContainer__uYYyW`,
	"loadMoreBtn": `Speeches_loadMoreBtn__o-ztp`,
	"showingCount": `Speeches_showingCount__RirQC`
};
export default ___CSS_LOADER_EXPORT___;
